module.exports = __webpack_public_path__ + "static/media/bike2-.904d53a0.png";